import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ArrowLeftIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'

/**
 * Adres karty, do której wraca „Powrót”, ze stanu nawigacji (`state.powrot`) albo null. Tylko ścieżka
 * w tej aplikacji (zaczyna się od jednego „/”), żeby stan nie wyprowadził użytkownika poza serwis.
 */
export const celPowrotu = (state) => {
  const p = state && typeof state === 'object' ? state.powrot : null
  return typeof p === 'string' && /^\/(?!\/)/.test(p) ? p : null
}

// Ten sam przycisk „Powrót", którego używamy w breadcrumbs na stronach produktów.
// Jeśli istnieje historia przeglądarki (wejście z listy) — cofamy się do niej, więc
// wracamy do listy z zachowanymi filtrami w query params. Jeśli użytkownik wszedł
// bezpośrednio z linku (brak historii) — używamy fallbacku do listy kategorii.
//
// Narzędzie otwarte z karty klienta (2026-10-11, runda 4): karta podaje swój adres w stanie nawigacji
// (`state.powrot`, np. „/klienci/12”) albo strona przekazuje go wprost (`powrot`, asystent w trybie klienta ma go
// w adresie). Wtedy „Powrót” zawsze prowadzi do tej karty, także po odświeżeniu strony narzędzia.
const BackButton = ({ className = '', fallback = '/', powrot = null }) => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const { t } = useTranslation('wspolne')
  const doKarty = celPowrotu({ powrot }) || celPowrotu(state)

  const handleBack = () => {
    if (doKarty) {
      navigate(doKarty)
      return
    }
    const idx = window.history.state && window.history.state.idx
    if (typeof idx === 'number' && idx > 0) {
      navigate(-1)
    } else {
      navigate(fallback)
    }
  }

  return (
    <button
      onClick={handleBack}
      aria-label={t('powrot_aria')}
      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-500 transition-colors flex-shrink-0 ${className}`}
    >
      <ArrowLeftIcon className="w-4 h-4" />
      {t('powrot')}
    </button>
  )
}

export default BackButton
